import { CargoDoc } from './CargoDoc'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { cacheName, cache } from '@/utils/cacheManager'
import {
  updateProperties,
  completeTheFeed,
  saveSeaCargoDoc,
  getSeaCargoDoc,
  toInsure,
  getEdiContainerList,
  getAfrAddressList,
  getFreightCharges,
  loadCargoDocRelated,
  getCfmAddress,
  getSeaCargoDocByJobUuid,
  affirmSeaCargoDocFunc,
  getGuaranteeStateInfo
} from '@/api/seaExport/seaCargoDoc'
import $store from '@/store'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { getIsfPassenger } from '@/api/seaExport/cargoDoc'
import * as BillType from '@/class/cargo/model/parameters/BillType'

export class SeaCargoDoc extends CargoDoc {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'SeaCargoDoc'
  }
  get subDocType2() {
    return this._data.subDocType2
  }
  set subDocType2(subDocType2) {
    this._data.subDocType2 = subDocType2
  }
  get mblNbr2() {
    return this._data.mblNbr2
  }
  set mblNbr2(mblNbr2) {
    this._data.mblNbr2 = mblNbr2
  }
  get quantitySum() {
    return this._data.quantitySum
  }
  set quantitySum(quantitySum) {
    this._data.quantitySum = quantitySum
  }
  get containerSum() {
    return this._data.containerSum
  }
  set containerSum(containerSum) {
    this._data.containerSum = containerSum
  }
  get loadingPort() {
    return this._data.loadingPort
  }
  set loadingPort(loadingPort) {
    this._data.loadingPort = loadingPort
  }
  get dischargingPort() {
    return this._data.dischargingPort
  }
  set dischargingPort(dischargingPort) {
    this._data.dischargingPort = dischargingPort
  }
  get destinationPort() {
    return this._data.destinationPort
  }
  set destinationPort(destinationPort) {
    this._data.destinationPort = destinationPort
  }
  get loadingPortCode() {
    return this._data.loadingPortCode
  }
  set loadingPortCode(loadingPortCode) {
    this._data.loadingPortCode = loadingPortCode
  }
  get dischargingPortCode() {
    return this._data.dischargingPortCode
  }
  set dischargingPortCode(dischargingPortCode) {
    this._data.dischargingPortCode = dischargingPortCode
  }
  get destinationPortCode() {
    return this._data.destinationPortCode
  }
  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode
  }
  get dispatchingPlaceCode() {
    return this._data.dispatchingPlaceCode
  }
  set dispatchingPlaceCode(dispatchingPlaceCode) {
    this._data.dispatchingPlaceCode = dispatchingPlaceCode
  }
  get dispatchingPlace() {
    return this._data.dispatchingPlace
  }
  set dispatchingPlace(dispatchingPlace) {
    this._data.dispatchingPlace = dispatchingPlace
  }
  get destinationPlace() {
    return this._data.destinationPlace
  }
  set destinationPlace(destinationPlace) {
    this._data.destinationPlace = destinationPlace
  }
  get paymentPlaceBL() {
    return this._data.paymentPlaceBL
  }
  set paymentPlaceBL(paymentPlaceBL) {
    this._data.paymentPlaceBL = paymentPlaceBL
  }
  get edi() {
    return this._data.edi
  }
  set edi(edi) {
    this._data.edi = edi || false
  }
  get manifestEDI() {
    return this._data.manifestEDI
  }
  set manifestEDI(manifestEDI) {
    this._data.manifestEDI = manifestEDI || false
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get printParam1() {
    return this._data.printParam1
  }
  set printParam1(printParam1) {
    this._data.printParam1 = printParam1 || false
  }
  get printParam2() {
    return this._data.printParam2
  }
  set printParam2(printParam2) {
    this._data.printParam2 = printParam2 || false
  }
  get printParam3() {
    return this._data.printParam3
  }
  set printParam3(printParam3) {
    this._data.printParam3 = printParam3 || false
  }
  get printParam4() {
    return this._data.printParam4
  }
  set printParam4(printParam4) {
    this._data.printParam4 = printParam4
  }
  get printParam5() {
    return this._data.printParam5
  }
  set printParam5(printParam5) {
    this._data.printParam5 = printParam5
  }
  get printParam6() {
    return this._data.printParam6
  }
  set printParam6(printParam6) {
    this._data.printParam6 = printParam6 || false
  }
  get serialNo() {
    return this._data.serialNo
  }
  set serialNo(serialNo) {
    this._data.serialNo = serialNo
  }
  get seaeq() {
    return this._data.seaeq
  }
  set seaeq(seaeq) {
    this._data.seaeq = seaeq
  }
  get container() {
    return this._data.container
  }
  set container(container) {
    this._data.container = container
  }
  get alsoNotify() {
    return this._data.alsoNotify
  }
  set alsoNotify(alsoNotify) {
    this._data.alsoNotify = alsoNotify
  }
  get costcoNo() {
    return this._data.costcoNo
  }
  set costcoNo(costcoNo) {
    this._data.costcoNo = costcoNo
  }
  get cargoManifestName() {
    return this._data.cargoManifestName
  }
  set cargoManifestName(cargoManifestName) {
    this._data.cargoManifestName = cargoManifestName
  }
  get mblId() {
    return this._data.mblId
  }
  set mblId(mblId) {
    this._data.mblId = mblId
  }
  get shipperTel() {
    return this._data.shipperTel
  }
  set shipperTel(shipperTel) {
    this._data.shipperTel = shipperTel
  }
  get consigneeTel() {
    return this._data.consigneeTel
  }
  set consigneeTel(consigneeTel) {
    this._data.consigneeTel = consigneeTel
  }
  get notifyTel() {
    return this._data.notifyTel
  }
  set notifyTel(notifyTel) {
    this._data.notifyTel = notifyTel
  }
  get releaseReview() {
    return this._data.releaseReview
  }
  set releaseReview(releaseReview) {
    this._data.releaseReview = releaseReview || 0
  }
  get reviewDate() {
    return this._data.reviewDate
  }
  set reviewDate(reviewDate) {
    this._data.reviewDate = reviewDate
  }
  get releaseState() {
    return this._data.releaseState
  }
  set releaseState(releaseState) {
    this._data.releaseState = releaseState || 0
  }
  get releaseDate() {
    return this._data.releaseDate
  }
  set releaseDate(releaseDate) {
    this._data.releaseDate = releaseDate
  }
  get bliStatus() {
    return this._data.bliStatus
  }
  set bliStatus(bliStatus) {
    this._data.bliStatus = bliStatus || 0
  }
  get payable() {
    return this._data.payable
  }
  set payable(payable) {
    this._data.payable = payable || false
  }
  get agreePayDate() {
    return this._data.agreePayDate
  }
  set agreePayDate(agreePayDate) {
    this._data.agreePayDate = agreePayDate
  }
  get withhold() {
    return this._data.withhold
  }
  set withhold(withhold) {
    this._data.withhold = withhold || false
  }
  get withholdDate() {
    return this._data.withholdDate
  }
  set withholdDate(withholdDate) {
    this._data.withholdDate = withholdDate
  }
  get withholdReason() {
    return this._data.withholdReason
  }
  set withholdReason(withholdReason) {
    this._data.withholdReason = withholdReason
  }
  get secondReleaseDate() {
    return this._data.secondReleaseDate
  }
  set secondReleaseDate(secondReleaseDate) {
    this._data.secondReleaseDate = secondReleaseDate
  }
  get surrenderedApplicant() {
    return this._data.surrenderedApplicant
  }
  set surrenderedApplicant(surrenderedApplicant) {
    this._data.surrenderedApplicant = surrenderedApplicant || 0
  }
  get surrenderedApplicationDate() {
    return this._data.surrenderedApplicationDate
  }
  set surrenderedApplicationDate(surrenderedApplicationDate) {
    this._data.surrenderedApplicationDate = surrenderedApplicationDate
  }
  get surrenderedNo() {
    return this._data.surrenderedNo
  }
  set surrenderedNo(surrenderedNo) {
    this._data.surrenderedNo = surrenderedNo
  }
  get customerCfmException() {
    return this._data.customerCfmException
  }
  set customerCfmException(customerCfmException) {
    this._data.customerCfmException = customerCfmException
  }
  get originalBLWay() {
    return this._data.originalBLWay
  }
  set originalBLWay(originalBLWay) {
    this._data.originalBLWay = originalBLWay || 0
  }
  get warehouseNo() {
    return this._data.warehouseNo
  }
  set warehouseNo(warehouseNo) {
    this._data.warehouseNo = warehouseNo
  }
  get freightTermHBL() {
    return this._data.freightTermHBL
  }
  set freightTermHBL(freightTermHBL) {
    this._data.freightTermHBL = freightTermHBL
  }
  get shipperContact() {
    return this._data.shipperContact
  }
  set shipperContact(shipperContact) {
    this._data.shipperContact = shipperContact
  }
  get shipperMobile() {
    return this._data.shipperMobile
  }
  set shipperMobile(shipperMobile) {
    this._data.shipperMobile = shipperMobile
  }
  get shipperFax() {
    return this._data.shipperFax
  }
  set shipperFax(shipperFax) {
    this._data.shipperFax = shipperFax
  }
  get shipperEmail() {
    return this._data.shipperEmail
  }
  set shipperEmail(shipperEmail) {
    this._data.shipperEmail = shipperEmail
  }
  get shipperZipCode() {
    return this._data.shipperZipCode
  }
  set shipperZipCode(shipperZipCode) {
    this._data.shipperZipCode = shipperZipCode
  }
  get shipperCity() {
    return this._data.shipperCity
  }
  set shipperCity(shipperCity) {
    this._data.shipperCity = shipperCity
  }
  get consigneeContact() {
    return this._data.consigneeContact
  }
  set consigneeContact(consigneeContact) {
    this._data.consigneeContact = consigneeContact
  }
  get consigneeMobile() {
    return this._data.consigneeMobile
  }
  set consigneeMobile(consigneeMobile) {
    this._data.consigneeMobile = consigneeMobile
  }
  get consigneeFax() {
    return this._data.consigneeFax
  }
  set consigneeFax(consigneeFax) {
    this._data.consigneeFax = consigneeFax
  }
  get consigneeEmail() {
    return this._data.consigneeEmail
  }
  set consigneeEmail(consigneeEmail) {
    this._data.consigneeEmail = consigneeEmail
  }
  get consigneeZipCode() {
    return this._data.consigneeZipCode
  }
  set consigneeZipCode(consigneeZipCode) {
    this._data.consigneeZipCode = consigneeZipCode
  }
  get consigneeCity() {
    return this._data.consigneeCity
  }
  set consigneeCity(consigneeCity) {
    this._data.consigneeCity = consigneeCity
  }
  get notifyContact() {
    return this._data.notifyContact
  }
  set notifyContact(notifyContact) {
    this._data.notifyContact = notifyContact
  }
  get notifyMobile() {
    return this._data.notifyMobile
  }
  set notifyMobile(notifyMobile) {
    this._data.notifyMobile = notifyMobile
  }
  get notifyFax() {
    return this._data.notifyFax
  }
  set notifyFax(notifyFax) {
    this._data.notifyFax = notifyFax
  }
  get notifyEmail() {
    return this._data.notifyEmail
  }
  set notifyEmail(notifyEmail) {
    this._data.notifyEmail = notifyEmail
  }
  get notifyZipCode() {
    return this._data.notifyZipCode
  }
  set notifyZipCode(notifyZipCode) {
    this._data.notifyZipCode = notifyZipCode
  }
  get notifyCity() {
    return this._data.notifyCity
  }
  set notifyCity(notifyCity) {
    this._data.notifyCity = notifyCity
  }
  get alsoNotifyCode() {
    return this._data.alsoNotifyCode
  }
  set alsoNotifyCode(alsoNotifyCode) {
    this._data.alsoNotifyCode = alsoNotifyCode
  }
  get alsoNotifyLine1() {
    return this._data.alsoNotifyLine1
  }
  set alsoNotifyLine1(alsoNotifyLine1) {
    this._data.alsoNotifyLine1 = alsoNotifyLine1
  }
  get alsoNotifyLine2() {
    return this._data.alsoNotifyLine2
  }
  set alsoNotifyLine2(alsoNotifyLine2) {
    this._data.alsoNotifyLine2 = alsoNotifyLine2
  }
  get alsoNotifyLine3() {
    return this._data.alsoNotifyLine3
  }
  set alsoNotifyLine3(alsoNotifyLine3) {
    this._data.alsoNotifyLine3 = alsoNotifyLine3
  }
  get alsoNotifyLine4() {
    return this._data.alsoNotifyLine4
  }
  set alsoNotifyLine4(alsoNotifyLine4) {
    this._data.alsoNotifyLine4 = alsoNotifyLine4
  }
  get alsoNotifyLine5() {
    return this._data.alsoNotifyLine5
  }
  set alsoNotifyLine5(alsoNotifyLine5) {
    this._data.alsoNotifyLine5 = alsoNotifyLine5
  }
  get alsoNotifyLine6() {
    return this._data.alsoNotifyLine6
  }
  set alsoNotifyLine6(alsoNotifyLine6) {
    this._data.alsoNotifyLine6 = alsoNotifyLine6
  }
  get alsoNotifyLine7() {
    return this._data.alsoNotifyLine7
  }
  set alsoNotifyLine7(alsoNotifyLine7) {
    this._data.alsoNotifyLine7 = alsoNotifyLine7
  }
  get alsoNotifyContact() {
    return this._data.alsoNotifyContact
  }
  set alsoNotifyContact(alsoNotifyContact) {
    this._data.alsoNotifyContact = alsoNotifyContact
  }
  get alsoNotifyMobile() {
    return this._data.alsoNotifyMobile
  }
  set alsoNotifyMobile(alsoNotifyMobile) {
    this._data.alsoNotifyMobile = alsoNotifyMobile
  }
  get alsoNotifyFax() {
    return this._data.alsoNotifyFax
  }
  set alsoNotifyFax(alsoNotifyFax) {
    this._data.alsoNotifyFax = alsoNotifyFax
  }
  get alsoNotifyEmail() {
    return this._data.alsoNotifyEmail
  }
  set alsoNotifyEmail(alsoNotifyEmail) {
    this._data.alsoNotifyEmail = alsoNotifyEmail
  }
  get alsoNotifyZipCode() {
    return this._data.alsoNotifyZipCode
  }
  set alsoNotifyZipCode(alsoNotifyZipCode) {
    this._data.alsoNotifyZipCode = alsoNotifyZipCode
  }
  get alsoNotifyCity() {
    return this._data.alsoNotifyCity
  }
  set alsoNotifyCity(alsoNotifyCity) {
    this._data.alsoNotifyCity = alsoNotifyCity
  }
  get dgconsignCode() {
    return this._data.dgconsignCode
  }
  set dgconsignCode(dgconsignCode) {
    this._data.dgconsignCode = dgconsignCode
  }
  get dgconsignLine1() {
    return this._data.dgconsignLine1
  }
  set dgconsignLine1(dgconsignLine1) {
    this._data.dgconsignLine1 = dgconsignLine1
  }
  get dgconsignLine2() {
    return this._data.dgconsignLine2
  }
  set dgconsignLine2(dgconsignLine2) {
    this._data.dgconsignLine2 = dgconsignLine2
  }
  get dgconsignLine3() {
    return this._data.dgconsignLine3
  }
  set dgconsignLine3(dgconsignLine3) {
    this._data.dgconsignLine3 = dgconsignLine3
  }
  get dgconsignLine4() {
    return this._data.dgconsignLine4
  }
  set dgconsignLine4(dgconsignLine4) {
    this._data.dgconsignLine4 = dgconsignLine4
  }
  get dgconsignLine5() {
    return this._data.dgconsignLine5
  }
  set dgconsignLine5(dgconsignLine5) {
    this._data.dgconsignLine5 = dgconsignLine5
  }
  get dgconsignLine6() {
    return this._data.dgconsignLine6
  }
  set dgconsignLine6(dgconsignLine6) {
    this._data.dgconsignLine6 = dgconsignLine6
  }
  get dgconsignLine7() {
    return this._data.dgconsignLine7
  }
  set dgconsignLine7(dgconsignLine7) {
    this._data.dgconsignLine7 = dgconsignLine7
  }
  get dgconsignContact() {
    return this._data.dgconsignContact
  }
  set dgconsignContact(dgconsignContact) {
    this._data.dgconsignContact = dgconsignContact
  }
  get dgconsignMobile() {
    return this._data.dgconsignMobile
  }
  set dgconsignMobile(dgconsignMobile) {
    this._data.dgconsignMobile = dgconsignMobile
  }
  get dgconsignFax() {
    return this._data.dgconsignFax
  }
  set dgconsignFax(dgconsignFax) {
    this._data.dgconsignFax = dgconsignFax
  }
  get dgconsignEmail() {
    return this._data.dgconsignEmail
  }
  set dgconsignEmail(dgconsignEmail) {
    this._data.dgconsignEmail = dgconsignEmail
  }
  get dgconsignZipCode() {
    return this._data.dgconsignZipCode
  }
  set dgconsignZipCode(dgconsignZipCode) {
    this._data.dgconsignZipCode = dgconsignZipCode
  }
  get dgconsignCity() {
    return this._data.dgconsignCity
  }
  set dgconsignCity(dgconsignCity) {
    this._data.dgconsignCity = dgconsignCity
  }
  get elseInvoiceCode() {
    return this._data.elseInvoiceCode
  }
  set elseInvoiceCode(elseInvoiceCode) {
    this._data.elseInvoiceCode = elseInvoiceCode
  }
  get elseInvoiceLine1() {
    return this._data.elseInvoiceLine1
  }
  set elseInvoiceLine1(elseInvoiceLine1) {
    this._data.elseInvoiceLine1 = elseInvoiceLine1
  }
  get elseInvoiceLine2() {
    return this._data.elseInvoiceLine2
  }
  set elseInvoiceLine2(elseInvoiceLine2) {
    this._data.elseInvoiceLine2 = elseInvoiceLine2
  }
  get elseInvoiceLine3() {
    return this._data.elseInvoiceLine3
  }
  set elseInvoiceLine3(elseInvoiceLine3) {
    this._data.elseInvoiceLine3 = elseInvoiceLine3
  }
  get elseInvoiceLine4() {
    return this._data.elseInvoiceLine4
  }
  set elseInvoiceLine4(elseInvoiceLine4) {
    this._data.elseInvoiceLine4 = elseInvoiceLine4
  }
  get elseInvoiceLine5() {
    return this._data.elseInvoiceLine5
  }
  set elseInvoiceLine5(elseInvoiceLine5) {
    this._data.elseInvoiceLine5 = elseInvoiceLine5
  }
  get elseInvoiceLine6() {
    return this._data.elseInvoiceLine6
  }
  set elseInvoiceLine6(elseInvoiceLine6) {
    this._data.elseInvoiceLine6 = elseInvoiceLine6
  }
  get elseInvoiceLine7() {
    return this._data.elseInvoiceLine7
  }
  set elseInvoiceLine7(elseInvoiceLine7) {
    this._data.elseInvoiceLine7 = elseInvoiceLine7
  }
  get elseInvoiceContact() {
    return this._data.elseInvoiceContact
  }
  set elseInvoiceContact(elseInvoiceContact) {
    this._data.elseInvoiceContact = elseInvoiceContact
  }
  get elseInvoiceMobile() {
    return this._data.elseInvoiceMobile
  }
  set elseInvoiceMobile(elseInvoiceMobile) {
    this._data.elseInvoiceMobile = elseInvoiceMobile
  }
  get elseInvoiceFax() {
    return this._data.elseInvoiceFax
  }
  set elseInvoiceFax(elseInvoiceFax) {
    this._data.elseInvoiceFax = elseInvoiceFax
  }
  get elseInvoiceEmail() {
    return this._data.elseInvoiceEmail
  }
  set elseInvoiceEmail(elseInvoiceEmail) {
    this._data.elseInvoiceEmail = elseInvoiceEmail
  }
  get elseInvoiceZipCode() {
    return this._data.elseInvoiceZipCode
  }
  set elseInvoiceZipCode(elseInvoiceZipCode) {
    this._data.elseInvoiceZipCode = elseInvoiceZipCode
  }
  get elseInvoiceCity() {
    return this._data.elseInvoiceCity
  }
  set elseInvoiceCity(elseInvoiceCity) {
    this._data.elseInvoiceCity = elseInvoiceCity
  }
  get showPODAgency() {
    return this._data.showPODAgency
  }
  set showPODAgency(showPODAgency) {
    this._data.showPODAgency = showPODAgency
  }
  get receivedDate() {
    return this._data.receivedDate
  }
  set receivedDate(receivedDate) {
    this._data.receivedDate = receivedDate
  }
  get getBackDate() {
    return this._data.getBackDate
  }
  set getBackDate(getBackDate) {
    this._data.getBackDate = getBackDate
  }
  get claimDate() {
    return this._data.claimDate
  }
  set claimDate(claimDate) {
    this._data.claimDate = claimDate
  }
  get customerSelfRelease() {
    return this._data.customerSelfRelease
  }
  set customerSelfRelease(customerSelfRelease) {
    this._data.customerSelfRelease = customerSelfRelease || 0
  }
  get seaExportJob() {
    return this._data.seaExportJob
  }
  set seaExportJob(seaExportJob) {
    this._data.seaExportJob = seaExportJob
  }
  get ediContainer() {
    return this._data.ediContainer
  }
  set ediContainer(ediContainer) {
    this._data.ediContainer = ediContainer
  }
  get afrAddress() {
    return this._data.afrAddress
  }
  set afrAddress(afrAddress) {
    this._data.afrAddress = afrAddress
  }
  get freightCharges() {
    return this._data.freightCharges
  }
  set freightCharges(freightCharges) {
    this._data.freightCharges = freightCharges
  }
  get isfPassenger() {
    return this._data.isfPassenger
  }
  set isfPassenger(isfPassenger) {
    this._data.isfPassenger = isfPassenger
  }
  // eManifest标记
  get printParam7() {
    return this._data.printParam7
  }
  set printParam7(printParam7) {
    this._data.printParam7 = printParam7
  }
  // 最后一个外国港口
  get lastAbroadProd() {
    return this._data.lastAbroadProd
  }
  set lastAbroadProd(lastAbroadProd) {
    this._data.lastAbroadProd = lastAbroadProd
  }
  // FROB类型
  get frob() {
    return this._data.frob
  }
  set frob(frob) {
    this._data.frob = frob
  }
  // 加拿大账户
  get emainAccount() {
    return this._data.emainAccount
  }
  set emainAccount(emainAccount) {
    this._data.emainAccount = emainAccount
  }
  // 内陆点/仓库
  get subLocationCode() {
    return this._data.subLocationCode
  }
  set subLocationCode(subLocationCode) {
    this._data.subLocationCode = subLocationCode
  }
  get dishSubLoc() {
    return this._data.dishSubLoc
  }
  set dishSubLoc(dishSubLoc) {
    this._data.dishSubLoc = dishSubLoc
  }
  // 加拿大海关备案号
  get recordNumber() {
    return this._data.recordNumber
  }
  set recordNumber(recordNumber) {
    this._data.recordNumber = recordNumber
  }
  // 提单类型
  get amsBlType() {
    return this._data.amsBlType
  }
  set amsBlType(amsBlType) {
    this._data.amsBlType = amsBlType
  }
  // 发货类型
  get shipmentTypeCode() {
    return this._data.shipmentTypeCode
  }
  set shipmentTypeCode(shipmentTypeCode) {
    this._data.shipmentTypeCode = shipmentTypeCode
  }
  // HBL NO
  get efHblNumber() {
    return this._data.efHblNumber
  }
  set efHblNumber(efHblNumber) {
    this._data.efHblNumber = efHblNumber
  }
  // 整拼类型
  get containerLoadType() {
    return this._data.containerLoadType
  }
  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType
  }
  // 船名
  get vessel() {
    return this._data.vessel
  }
  set vessel(vessel) {
    this._data.vessel = vessel
  }
  // 航次
  get voyageFlight() {
    return this._data.voyageFlight
  }
  set voyageFlight(voyageFlight) {
    this._data.voyageFlight = voyageFlight
  }
  // 最后一个境外港口
  get lastAbroadProdName() {
    return this._data.lastAbroadProdName
  }
  set lastAbroadProdName(lastAbroadProdName) {
    this._data.lastAbroadProdName = lastAbroadProdName
  }
  // 无船承运人SCAC
  get nvoccScac() {
    return this._data.nvoccScac
  }
  set nvoccScac(nvoccScac) {
    this._data.nvoccScac = nvoccScac
  }
  get efNvoccScac() {
    return this._data.efNvoccScac
  }
  set efNvoccScac(efNvoccScac) {
    this._data.efNvoccScac = efNvoccScac
  }
  // 船舶编号
  get vesselIMO() {
    return this._data.vesselIMO
  }
  set vesselIMO(vesselIMO) {
    this._data.vesselIMO = vesselIMO
  }
  // 加拿大账户ACI
  get emainAccountAci() {
    return this._data.emainAccountAci
  }
  set emainAccountAci(emainAccountAci) {
    this._data.emainAccountAci = emainAccountAci
  }
  // 第一个停靠港代码
  get firstPortOfCallCode() {
    return this._data.firstPortOfCallCode
  }
  set firstPortOfCallCode(firstPortOfCallCode) {
    this._data.firstPortOfCallCode = firstPortOfCallCode
  }
  // 第一个停靠港
  get firstPortOfCall() {
    return this._data.firstPortOfCall
  }
  set firstPortOfCall(firstPortOfCall) {
    this._data.firstPortOfCall = firstPortOfCall
  }
  // 预计交回日期
  get estimatedDeliveryDate() {
    return this._data.estimatedDeliveryDate
  }
  set estimatedDeliveryDate(estimatedDeliveryDate) {
    this._data.estimatedDeliveryDate = estimatedDeliveryDate
  }
  // 接收操作人
  get receivedOperator() {
    return this._data.receivedOperator
  }
  set receivedOperator(receivedOperator) {
    this._data.receivedOperator = receivedOperator
  }
  // 认领操作人
  get claimOperator() {
    return this._data.claimOperator
  }
  set claimOperator(claimOperator) {
    this._data.claimOperator = claimOperator
  }
  // 改单操作人
  get orderChangeOperator() {
    return this._data.orderChangeOperator
  }
  set orderChangeOperator(orderChangeOperator) {
    this._data.orderChangeOperator = orderChangeOperator
  }
  // 改单操作时间
  get changeOrderOperationTime() {
    return this._data.changeOrderOperationTime
  }
  set changeOrderOperationTime(changeOrderOperationTime) {
    this._data.changeOrderOperationTime = changeOrderOperationTime
  }
  get confirmationBillState() {
    return this._data.confirmationBillState
  }
  set confirmationBillState(confirmationBillState) {
    this._data.confirmationBillState = confirmationBillState
  }
  // 船舶呼号
  get vesselCode() {
    return this._data.vesselCode
  }
  set vesselCode(vesselCode) {
    this._data.vesselCode = vesselCode
  }
  // 申请放单时间
  get requestReleaseTime() {
    return this._data.requestReleaseTime
  }
  set requestReleaseTime(requestReleaseTime) {
    this._data.requestReleaseTime = requestReleaseTime
  }
  // 申请放单状态 0--未申请，1--已申请
  get requestReleaseState() {
    return this._data.requestReleaseState
  }
  set requestReleaseState(requestReleaseState) {
    this._data.requestReleaseState = requestReleaseState || 0
  }
  // 申请放单人
  get requestReleaseBy() {
    return this._data.requestReleaseBy
  }
  set requestReleaseBy(requestReleaseBy) {
    this._data.requestReleaseBy = requestReleaseBy
  }

  get nationalityCodeofVessel() {
    return this._data.nationalityCodeofVessel
  }
  set nationalityCodeofVessel(nationalityCodeofVessel) {
    this._data.nationalityCodeofVessel = nationalityCodeofVessel
  }

  get paperlessInBondParticipant() {
    return this._data.paperlessInBondParticipant
  }
  set paperlessInBondParticipant(paperlessInBondParticipant) {
    this._data.paperlessInBondParticipant = paperlessInBondParticipant
  }

  get goodsType() {
    return this._data.goodsType
  }
  set goodsType(goodsType) {
    this._data.goodsType = goodsType
  }

  get hazardousCode() {
    return this._data.hazardousCode
  }
  set hazardousCode(hazardousCode) {
    this._data.hazardousCode = hazardousCode
  }

  get flashPointTemp() {
    return this._data.flashPointTemp
  }
  set flashPointTemp(flashPointTemp) {
    this._data.flashPointTemp = flashPointTemp
  }

  get cargoDestinationCountry() {
    return this._data.cargoDestinationCountry
  }
  set cargoDestinationCountry(cargoDestinationCountry) {
    this._data.cargoDestinationCountry = cargoDestinationCountry
  }

  get cargoDestinationCity() {
    return this._data.cargoDestinationCity
  }
  set cargoDestinationCity(cargoDestinationCity) {
    this._data.cargoDestinationCity = cargoDestinationCity
  }

  get undgCode() {
    return this._data.undgCode
  }
  set undgCode(undgCode) {
    this._data.undgCode = undgCode
  }

  get imdgClass() {
    return this._data.imdgClass
  }
  set imdgClass(imdgClass) {
    this._data.imdgClass = imdgClass
  }

  get unNo() {
    return this._data.unNo
  }
  set unNo(unNo) {
    this._data.unNo = unNo
  }

  get cusCode() {
    return this._data.cusCode
  }
  set cusCode(cusCode) {
    this._data.cusCode = cusCode
  }

  get ncmNo() {
    return this._data.ncmNo
  }
  set ncmNo(ncmNo) {
    this._data.ncmNo = ncmNo
  }

  get showDetail() {
    return this._data.showDetail
  }
  set showDetail(showDetail) {
    this._data.showDetail = showDetail
  }
  get paymentLine1() {
    return this._data.paymentLine1
  }
  set paymentLine1(paymentLine1) {
    this._data.paymentLine1 = paymentLine1
  }

  get paymentLine2() {
    return this._data.paymentLine2
  }
  set paymentLine2(paymentLine2) {
    this._data.paymentLine2 = paymentLine2
  }

  get paymentLine3() {
    return this._data.paymentLine3
  }
  set paymentLine3(paymentLine3) {
    this._data.paymentLine3 = paymentLine3
  }

  get paymentLine4() {
    return this._data.paymentLine4
  }
  set paymentLine4(paymentLine4) {
    this._data.paymentLine4 = paymentLine4
  }
  get paymentLine5() {
    return this._data.paymentLine5
  }
  set paymentLine5(paymentLine5) {
    this._data.paymentLine5 = paymentLine5
  }

  get paymentLine6() {
    return this._data.paymentLine6
  }
  set paymentLine6(paymentLine6) {
    this._data.paymentLine6 = paymentLine6
  }

  get paymentLine7() {
    return this._data.paymentLine7
  }
  set paymentLine7(paymentLine7) {
    this._data.paymentLine7 = paymentLine7
  }
  get paymentCountry() {
    return this._data.paymentCountry
  }
  set paymentCountry(paymentCountry) {
    this._data.paymentCountry = paymentCountry
  }
  get alsoNotifyCountry() {
    return this._data.alsoNotifyCountry
  }
  set alsoNotifyCountry(alsoNotifyCountry) {
    this._data.alsoNotifyCountry = alsoNotifyCountry
  }
  get paymentCity() {
    return this._data.paymentCity
  }
  set paymentCity(paymentCity) {
    this._data.paymentCity = paymentCity
  }

  get paymentProvince() {
    return this._data.paymentProvince
  }
  set paymentProvince(paymentProvince) {
    this._data.paymentProvince = paymentProvince
  }

  get paymentPostalCode() {
    return this._data.paymentPostalCode
  }
  set paymentPostalCode(paymentPostalCode) {
    this._data.paymentPostalCode = paymentPostalCode
  }
  get paymentPhone() {
    return this._data.paymentPhone
  }
  set paymentPhone(paymentPhone) {
    this._data.paymentPhone = paymentPhone
  }
  get paymentEmail() {
    return this._data.paymentEmail
  }
  set paymentEmail(paymentEmail) {
    this._data.paymentEmail = paymentEmail
  }
  get paymentContact() {
    return this._data.paymentContact
  }
  set paymentContact(paymentContact) {
    this._data.paymentContact = paymentContact
  }
  get paymentFax() {
    return this._data.paymentFax
  }
  set paymentFax(paymentFax) {
    this._data.paymentFax = paymentFax
  }
  get coloadInSelfFilingIndicator() {
    return this._data.coloadInSelfFilingIndicator
  }
  set coloadInSelfFilingIndicator(coloadInSelfFilingIndicator) {
    this._data.coloadInSelfFilingIndicator = coloadInSelfFilingIndicator
  }
  get carrierEori() {
    return this._data.carrierEori
  }
  set carrierEori(carrierEori) {
    this._data.carrierEori = carrierEori
  }
  get routeCountry() {
    return this._data.routeCountry
  }
  set routeCountry(routeCountry) {
    this._data.routeCountry = routeCountry
  }
  get chargesPaymentMethod() {
    return this._data.chargesPaymentMethod
  }
  set chargesPaymentMethod(chargesPaymentMethod) {
    this._data.chargesPaymentMethod = chargesPaymentMethod
  }
  get declaringMemberCountry() {
    return this._data.declaringMemberCountry
  }
  set declaringMemberCountry(declaringMemberCountry) {
    this._data.declaringMemberCountry = declaringMemberCountry
  }
  get declarantEori() {
    return this._data.declarantEori
  }
  set declarantEori(declarantEori) {
    this._data.declarantEori = declarantEori
  }
  get multipleHbl() {
    return this._data.multipleHbl
  }
  set multipleHbl(multipleHbl) {
    this._data.multipleHbl = multipleHbl
  }
  get declarationType() {
    return this._data.declarationType
  }
  set declarationType(declarationType) {
    this._data.declarationType = declarationType
  }

  // 扩展属性 不参与后端保存 ==================
  get chargePrint() {
    return this._data.chargePrint
  }
  set chargePrint(chargePrint) {
    this._data.chargePrint = chargePrint || false
  }
  // 针对新增以后，再把新增的对象删除掉的情景。增加临时序号字段，新增的时候使用此字段，然后再删除的时候根据此字段进行判断，进行精确移除
  get temporarySerialNumber() {
    return this._data.temporarySerialNumber
  }
  set temporarySerialNumber(temporarySerialNumber) {
    this._data.temporarySerialNumber = temporarySerialNumber || 0
  }
  // 针对反恐舱单通过Add新增AFR的情景，如果是通过Add新增的，fromAdd为true  不参与后端保存
  get fromAdd() {
    return this._data.fromAdd
  }

  set fromAdd(fromAdd) {
    this._data.fromAdd = fromAdd
  }

  get vesselVoyage() {
    return this._data.vesselVoyage
  }

  set vesselVoyage(vesselVoyage) {
    this._data.vesselVoyage = vesselVoyage
  }

  // 第一个停靠港停靠日期
  get etaFirstPortOfCall() {
    return this._data.etaFirstPortOfCall
  }
  set etaFirstPortOfCall(etaFirstPortOfCall) {
    this._data.etaFirstPortOfCall = etaFirstPortOfCall
  }

  // 复制到买家，卖家
  get copyToSeller() {
    return this._data.copyToSeller
  }
  set copyToSeller(copyToSeller) {
    this._data.copyToSeller = copyToSeller
  }
  get copyToBuyer() {
    return this._data.copyToBuyer
  }
  set copyToBuyer(copyToBuyer) {
    this._data.copyToBuyer = copyToBuyer
  }
  get noHouseNumberByShipper() {
    return this._data.noHouseNumberByShipper
  }
  set noHouseNumberByShipper(noHouseNumberByShipper) {
    this._data.noHouseNumberByShipper = noHouseNumberByShipper
  }
  get noHouseNumberByConsignee() {
    return this._data.noHouseNumberByConsignee
  }
  set noHouseNumberByConsignee(noHouseNumberByConsignee) {
    this._data.noHouseNumberByConsignee = noHouseNumberByConsignee
  }
  get noHouseNumberBySeller() {
    return this._data.noHouseNumberBySeller
  }
  set noHouseNumberBySeller(noHouseNumberBySeller) {
    this._data.noHouseNumberBySeller = noHouseNumberBySeller
  }
  get noHouseNumberByBuyer() {
    return this._data.noHouseNumberByBuyer
  }
  set noHouseNumberByBuyer(noHouseNumberByBuyer) {
    this._data.noHouseNumberByBuyer = noHouseNumberByBuyer
  }

  // partyCode
  get partyCode() {
    return this._data.partyCode
  }
  set partyCode(partyCode) {
    this._data.partyCode = partyCode
  }

  get partyName() {
    return this._data.partyName
  }
  set partyName(partyName) {
    this._data.partyName = partyName
  }

  get partyAddressLine() {
    return this._data.partyAddressLine
  }
  set partyAddressLine(partyAddressLine) {
    this._data.partyAddressLine = partyAddressLine
  }

  get partyCountryCode() {
    return this._data.partyCountryCode
  }
  set partyCountryCode(partyCountryCode) {
    this._data.partyCountryCode = partyCountryCode
  }

  get partyCity() {
    return this._data.partyCity
  }
  set partyCity(partyCity) {
    this._data.partyCity = partyCity
  }

  get partyProvince() {
    return this._data.partyProvince
  }
  set partyProvince(partyProvince) {
    this._data.partyProvince = partyProvince
  }

  get partyZipCode() {
    return this._data.partyZipCode
  }
  set partyZipCode(partyZipCode) {
    this._data.partyZipCode = partyZipCode
  }

  get guaranteeConfigEnable() {
    return this._data.guaranteeConfigEnable
  }
  set guaranteeConfigEnable(guaranteeConfigEnable) {
    this._data.guaranteeConfigEnable = guaranteeConfigEnable
  }
  get singleTicketGuaranteeState() {
    return this._data.singleTicketGuaranteeState
  }
  set singleTicketGuaranteeState(singleTicketGuaranteeState) {
    this._data.singleTicketGuaranteeState = singleTicketGuaranteeState
  }
  get longTermGuaranteeState() {
    return this._data.longTermGuaranteeState
  }
  set longTermGuaranteeState(longTermGuaranteeState) {
    this._data.longTermGuaranteeState = longTermGuaranteeState
  }

  static newCargoDoc(model, docType) {
    const cargoDoc = new SeaCargoDoc().fillDefaultValue().getData()
    cargoDoc.jobUuid = model.uuid
    cargoDoc.docType = docType
    cargoDoc.mark = model.mark
    cargoDoc.cargoEnglishName = model.cargoEnglishName
    if (!cargoDoc.notifyLine1) {
      cargoDoc.notifyLine1 = 'SAME AS CONSIGNEE'
    }
    this.copyInfoFromSeaExportJob(model, cargoDoc).then(r => {})
    return cargoDoc
  }
  static async copyInfoFromSeaExportJob(job, doc) {
    if (doc.state > 1) return
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    // 提单发货地，应该是seaopinput.placeOfReceipt
    doc.dispatchingPlace = job.dispatchingPlace
    if (job.dispatchingPlaceCode) {
      const ports = seaPorts.filter(p => p.code === job.dispatchingPlaceCode)
      if (ports.length > 0) {
        doc.dispatchingPlaceCode = job.dispatchingPlaceCode
      }
    }
    // 提单起运港
    if (job.loadingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports.length > 0) {
        doc.loadingPort = ports[0].englishName
      }
      doc.loadingPortCode = job.loadingPortCode
    }
    // 提单卸货港
    if (job.dischargingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.dischargingPortCode)
      if (ports.length > 0) {
        doc.dischargingPort = ports[0].englishName
      }
      doc.dischargingPortCode = job.dischargingPortCode
    }
    // 提单目的港
    if (job.destinationPortCode) {
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports.length > 0) {
        doc.destinationPort = ports[0].englishName
      }
      doc.destinationPortCode = job.destinationPortCode
    }
    if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
      // 提单收货地
      doc.destinationPlace = job.destinationPlace
    }
    if (doc.docType === 'MBL' && job.masterFlag) {
      const office = $store.getters.currentOffice
      if (office) {
        doc.shipperLine1 = office.seaAddressLine1
        doc.shipperLine2 = office.seaAddressLine2
        doc.shipperLine3 = office.seaAddressLine3
        doc.shipperLine4 = office.seaAddressLine4
        doc.shipperLine5 = office.seaAddressLine5
        doc.shipperLine6 = office.seaAddressLine6
      }
    }
    await cache.load(cacheName.CONFIG)
    const config = cache.config
    const billOfLadingSynMode = Number(config.get('BillOfLadingSynMode'))
    if ([1, 2, 3].includes(billOfLadingSynMode)) {
      doc.quantity = job.quantityActual
      doc.weight = job.weightActual
      doc.cubage = job.cubageActual
      doc.chargeWeight = job.chargeWeight
      if (billOfLadingSynMode !== 3) {
        doc.packing = job.packing
        const packing = getObjectByCache(TYPE_NAMES.basic_data_Packing, 'code', job.packing)
        doc.packingName = packing ? packing.name : '' // 包装显示名
      }
    }
    // 根据参数判断是否同步小件数包装
    const isInsidePacking = Number(config.get('seaInsidePacking'))
    if (isInsidePacking === 1) {
      doc.insidePacking = job.insidePacking
    }
    // doc.issuerBL = 'UBI'
    ColumnUtils.customOrderFormTypeFunc(doc)
    // 新增时，如果已经选择提单方式，会重置为默认值
    if (doc.releaseType === 0) {
      const releaseType = Number(config.get('ReleaseTypeDefaultValue'))
      if (releaseType === 1) {
        doc.releaseType = 1
        doc.blNumber = 'THREE'
      } else if (releaseType === 2) {
        doc.releaseType = 3
        doc.blNumber = 'ONE'
      } else if (releaseType === 4) {
        let type
        if (doc.docType === 'MBL') {
          type = LocalStorageUtilsNew.getConfiguration('SE_MBL_BL_MODEL')
        } else if (doc.docType === 'HBL') {
          type = LocalStorageUtilsNew.getConfiguration('SE_HBL_BL_MODEL')
        }
        doc.releaseType = type || 1
        doc.BLNumber = 'ONE'
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        }
      }
    } else { // 重置提单份数
      if (doc.releaseType === 1) {
        doc.blNumber = 'THREE'
      } else {
        doc.blNumber = 'ONE'
      }
    }
    doc.state = 1
  }
  static async copyInfoFromJobPort(job, doc) {
    if (doc.state > 1) {
      return
    }
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    // 提单发货地，应该是seaopinput.placeOfReceipt
    doc.dispatchingPlace = job.dispatchingPlace
    // 提单起运港
    if (job.loadingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports.length > 0) {
        doc.loadingPort = ports[0].englishName
        doc.loadingPortCode = job.loadingPortCode
      }
    }
    // 提单卸货港
    if (job.dischargingPortCode) {
      const ports = seaPorts.filter(p => p.code === job.dischargingPortCode)
      if (ports.length > 0) {
        doc.dischargingPort = ports[0].englishName
        doc.dischargingPortCode = job.dischargingPortCode
      }
    }
    // 提单目的港
    if (job.destinationPortCode) {
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports.length > 0) {
        doc.destinationPort = ports[0].englishName
        doc.destinationPortCode = job.destinationPortCode
      }
    }
    if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
      // 提单收货地
      doc.destinationPlace = job.destinationPlace
    }
  }
  static async updateProperties(uuids, props) {
    return await updateProperties(props, uuids).then(res => res.data)
  }
  static async completeTheFeed(uuid, version) {
    return await completeTheFeed({ uuid, version }).then(res => res.data)
  }
  static async getSeaCargoDoc(uuid) {
    return await getSeaCargoDoc({ uuid }).then(res => res.data)
  }
  static async getSeaCargoDocByJobUuid(jobUuid) {
    return await getSeaCargoDocByJobUuid({ jobUuid }).then(res => res.data)
  }
  static async toInsure(companyName, seaCargoDoc, job, office) {
    return await toInsure({ companyName, seaCargoDoc, job, office }).then(res => res.data)
  }
  static async getCfmAddress(cargoDocUuid, version, tenantName, jobNo, officeId, inviterEmail) {
    return await getCfmAddress({ cargoDocUuid, version, tenantName, jobNo, officeId, inviterEmail }).then(res => res.data)
  }
  async save() {
    return await saveSeaCargoDoc(this._data)
  }
  async affirmSeaCargoDoc() {
    return affirmSeaCargoDocFunc(this._data)
  }
  async getEdiContainer() {
    const data = this._data
    if (typeof data.ediContainer !== 'object') {
      if (data.uuid) {
        data.ediContainer = await getEdiContainerList({ cargoDocUuid: data.uuid }).then(res => res.data)
      } else {
        data.ediContainer = []
      }
    }
    return data.ediContainer
  }
  async getAfrAddress() {
    const data = this._data
    if (typeof data.afrAddress !== 'object') {
      if (data.uuid) {
        data.afrAddress = await getAfrAddressList({ cargoDocUuid: data.uuid }).then(res => res.data)
      } else {
        data.afrAddress = []
      }
    }
    return data.afrAddress
  }

  /**
   * 查询HBL关联的保函信息
   * @returns {Promise<*>}
   */
  async loadGuaranteeStateInfo() {
    const data = this._data
    if (data.uuid) {
      const guaranteeStateInfo = await getGuaranteeStateInfo({ cargoDocUuid: data.uuid }).then(res => res.data)
      // 长期保函状态：0-无保函，1-生效中，2-已生效
      // 单票保函状态：0-未上传，1-已上传，2-无需上传
      if (guaranteeStateInfo) {
        data.longTermGuaranteeState = guaranteeStateInfo.longTermGuaranteeState
        data.singleTicketGuaranteeState = guaranteeStateInfo.singleTicketGuaranteeState
        data.guaranteeConfigEnable = guaranteeStateInfo.configEnable
      }
    } else {
      data.longTermGuaranteeState = 0
      data.singleTicketGuaranteeState = 0
      data.guaranteeConfigEnable = 0
    }
  }

  async getFreightCharges() {
    const data = this._data
    if (typeof data.freightCharges !== 'object') {
      if (data.uuid) {
        data.freightCharges = await getFreightCharges({ cargoDocUuid: data.uuid }).then(res => res.data)
      } else {
        data.freightCharges = []
      }
    }
    return data.freightCharges
  }
  // 加载提单相关信息
  async loadCargoDocRelated(afrAddress, ediContainer, freightCharges) {
    const data = this._data
    if (typeof data.afrAddress === 'object') {
      afrAddress = false
    }
    if (typeof data.ediContainer === 'object') {
      ediContainer = false
    }
    if (typeof data.freightCharges === 'object') {
      freightCharges = false
    }
    if (!afrAddress && !ediContainer && !freightCharges) {
      return
    }
    if (data.uuid) {
      await loadCargoDocRelated({ cargoDocUuid: data.uuid, afrAddress, ediContainer, freightCharges }).then(res => {
        const items = res.data
        for (const key in items) {
          data[key] = items[key] || null
        }
      })

      if (this.job.typeHBL !== BillType.SPLIT_BILL_TYPE.code) {
        await this.loadGuaranteeStateInfo()
      }
    } else {
      if (afrAddress) {
        data.afrAddress = data.afrAddress || []
      }
      if (ediContainer) {
        data.ediContainer = data.ediContainer || []
      }
      if (freightCharges) {
        data.freightCharges = data.freightCharges || []
      }
    }
  }
  async getIsfPassenger() {
    const data = this._data
    if (typeof data.isfPassenger !== 'object') {
      if (data.uuid) {
        data.isfPassenger = await getIsfPassenger({ cargoDocUuid: data.uuid }).then(res => res.data)
      } else {
        data.isfPassenger = []
      }
    }
    return data.isfPassenger
  }
  // 基本属性的复制
  copyBasic(source) {
    super.copyBasic(source)
    this.dispatchingPlace = source.dispatchingPlace
    this.loadingPort = source.loadingPort
    this.dischargingPort = source.dischargingPort
    this.destinationPort = source.destinationPort
    this.destinationPlace = source.destinationPlace
    this.paymentPlaceBL = source.paymentPlaceBL
    this.signPlaceBL = source.signPlaceBL
  }
  /**
   * 处理申请放单(会自动放单，也需要更新放单字段)
   * @param doc
   * @returns {Promise<void>}
   */
  static async handlerCargoDocForRequestRelease(doc) {
    if (!doc || !doc.uuid) {
      return
    }
    const entity = await this.getSeaCargoDoc(doc.uuid)
    if (entity) {
      doc.releaseState = entity.releaseState
      doc.releaseDate = entity.releaseDate
      doc.releaseBy = entity.releaseBy
      doc.requestReleaseState = entity.requestReleaseState
      doc.requestReleaseTime = entity.requestReleaseTime
      doc.requestReleaseBy = entity.requestReleaseBy
    }
  }

  static async createCargoDoc(model, docType) {
    const cargoDoc = new SeaCargoDoc().fillDefaultValue().getData()
    cargoDoc.jobUuid = model.uuid
    cargoDoc.docType = docType
    cargoDoc.mark = model.mark
    cargoDoc.cargoEnglishName = model.cargoEnglishName
    if (!cargoDoc.notifyLine1) {
      cargoDoc.notifyLine1 = 'SAME AS CONSIGNEE'
    }
    await this.copyInfoFromSeaExportJob(model, cargoDoc)
    return cargoDoc
  }
}
